<div class="recovery" data-testid="mfa-recovery-panel">
  <div class="recovery__title">{{ 'settings_security.recovery.title' | translate }}</div>

  <ui-auth-error-banner *ngIf="error" [error]="error"></ui-auth-error-banner>

  <!-- Plain interpolation: no innerHTML, no bypassSecurityTrust*, matching
       how the QR image is bound. -->
  <ng-container *ngIf="batch as batch; else summary">
    <p class="recovery__notice" data-testid="mfa-recovery-shown-once">
      {{ 'settings_security.recovery.shown_once' | translate }}
    </p>

    <ol class="recovery__codes" data-testid="mfa-recovery-codes">
      <li class="recovery__code" *ngFor="let code of batch">
        <code>{{ code }}</code>
      </li>
    </ol>

    <div class="recovery__actions">
      <ui-button
        type="secondary"
        testId="mfa-recovery-copy"
        [label]="
          (copied
            ? 'settings_security.recovery.copied'
            : 'settings_security.recovery.copy'
          ) | translate
        "
        (click)="copyCodes()"
      ></ui-button>
      <ui-button
        type="secondary"
        testId="mfa-recovery-download"
        [label]="'settings_security.recovery.download' | translate"
        (click)="downloadCodes()"
      ></ui-button>
      <ui-button
        type="primary"
        testId="mfa-recovery-ack"
        [label]="'settings_security.recovery.saved_acknowledge' | translate"
        (click)="dismiss()"
      ></ui-button>
    </div>
  </ng-container>

  <!-- Four states: "never had any" and "spent them all" need different
       words. -->
  <ng-template #summary>
    <p class="recovery__lede">{{ 'settings_security.recovery.lede' | translate }}</p>

    <p
      class="recovery__lede"
      *ngIf="neverGenerated"
      data-testid="mfa-recovery-none-yet"
    >
      {{ 'settings_security.recovery.never_generated' | translate }}
    </p>

    <p
      class="recovery__notice recovery__notice--warn"
      *ngIf="exhausted"
      data-testid="mfa-recovery-none-left"
    >
      {{ 'settings_security.recovery.none_left' | translate }}
    </p>

    <p
      class="recovery__notice recovery__notice--warn"
      *ngIf="low"
      data-testid="mfa-recovery-low"
    >
      {{ 'settings_security.recovery.low_warning' | translate: { count: remaining } }}
    </p>

    <p
      class="recovery__lede"
      *ngIf="!neverGenerated && !exhausted && !low"
      data-testid="mfa-recovery-remaining"
    >
      {{ 'settings_security.recovery.remaining' | translate: { count: remaining } }}
    </p>

    <ng-container *ngIf="!requesting; else stepUp">
      <div class="recovery__actions">
        <ui-button
          type="secondary"
          testId="mfa-recovery-generate"
          [label]="
            (neverGenerated
              ? 'settings_security.recovery.generate'
              : 'settings_security.recovery.regenerate'
            ) | translate
          "
          [disabled]="disabled || loading"
          (click)="startGenerate()"
        ></ui-button>
      </div>
    </ng-container>

    <ng-template #stepUp>
      <!-- Say this before taking the code, not after. -->
      <p
        class="recovery__notice recovery__notice--warn"
        *ngIf="!neverGenerated"
        data-testid="mfa-recovery-regenerate-warning"
      >
        {{ 'settings_security.recovery.regenerate_confirm' | translate }}
      </p>

      <form
        class="recovery__form"
        [formGroup]="stepUpForm"
        (ngSubmit)="confirmGenerate()"
        (keydown.enter)="onEnterGenerate($event)"
      >
        <ui-form-field
          [id]="'mfa-recovery-step-up'"
          testId="mfa-recovery-step-up"
          type="text"
          formControlName="code"
          autocomplete="one-time-code"
          inputMode="numeric"
          [maxLength]="6"
          [label]="'settings_security.step_up_code' | translate"
        ></ui-form-field>

        <p class="recovery__lede">
          {{ 'settings_security.recovery.step_up_help' | translate }}
        </p>

        <div class="recovery__actions">
          <ui-button
            type="primary"
            testId="mfa-recovery-confirm"
            [label]="'settings_security.recovery.generate' | translate"
            [disabled]="loading"
          ></ui-button>

          <!-- The only route to a code for an email-OTP-only user. -->
          <button
            *ngIf="canSendEmailCode"
            type="button"
            class="recovery__link"
            data-testid="mfa-recovery-send-code"
            [disabled]="sendingCode || codeResendWait > 0"
            (click)="sendStepUpCode()"
          >
            <ng-container *ngIf="codeResendWait > 0; else sendCodeNow">
              {{ 'settings_security.resend_in' | translate: { seconds: codeResendWait } }}
            </ng-container>
            <ng-template #sendCodeNow>
              {{ 'settings_security.send_code_by_email' | translate }}
            </ng-template>
          </button>

          <button type="button" class="recovery__link" (click)="cancelGenerate()">
            {{ 'common.cancel' | translate }}
          </button>
        </div>
      </form>
    </ng-template>
  </ng-template>
</div>
